import { apiClient } from '@/lib/api-client';
import type { ApiResponse, LoginRequest, LoginResponse, RegisterRequest, User } from '@/types/api';

export async function login(data: LoginRequest): Promise<ApiResponse<LoginResponse>> {
  const response = await apiClient.post<ApiResponse<LoginResponse>>('/auth/login', data);
  return response.data;
}

export async function register(data: RegisterRequest): Promise<ApiResponse<null>> {
  const response = await apiClient.post<ApiResponse<null>>('/auth/register', data);
  return response.data;
}

export async function getCurrentUser(): Promise<ApiResponse<User>> {
  const response = await apiClient.get<ApiResponse<User>>('/auth/me');
  return response.data;
}

export async function forgotPassword(email: string): Promise<ApiResponse<null>> {
  const response = await apiClient.post<ApiResponse<null>>('/auth/forgot-password', { email });
  return response.data;
}

export async function resetPassword(token: string, newPassword: string): Promise<ApiResponse<null>> {
  const response = await apiClient.post<ApiResponse<null>>('/auth/reset-password', { token, newPassword });
  return response.data;
}

export async function signOut(): Promise<void> {
  // Best-effort server-side sign-out — bulk-revokes this user's active
  // pairing tokens so phone sessions die alongside the PC session. Failures
  // are swallowed: the client still clears its local state either way.
  try {
    await apiClient.post('/auth/sign-out');
  } catch {
    // silent — local sign-out still proceeds
  }
}
